import { openSnackbar } from "api/snackbar";
import { enqueueSnackbar } from "notistack";
import { SnackbarProps } from "types/snackbar";

export function showSuccess(
  message: string,
  v?: "top" | "bottom",
  h?: "left" | "center" | "right"
) {
  openSnackbar({
    open: true,
    message: message,
    anchorOrigin: { vertical: v ?? "top", horizontal: h ?? "right" },
    variant: "alert",
    alert: {
      color: "success",
    },
  } as SnackbarProps);
}

export function showEnqueueSnackbar(
  message: string,
  v?: "top" | "bottom",
  h?: "left" | "center" | "right"
) {
  enqueueSnackbar(message, {
    anchorOrigin: { vertical: v ?? "top", horizontal: h ?? "right" },
    variant: "success",
    autoHideDuration: 1200,
    preventDuplicate: true,
  });
}

export function showError(message: string, v?: string, h?: string) {
  openSnackbar({
    open: true,
    message: message,
    anchorOrigin: { vertical: v ?? "top", horizontal: h ?? "right" },
    variant: "alert",
    alert: {
      color: "error",
    },
  } as SnackbarProps);
}
